(() => {
  // 規約同意チェック
  const termsCheck = document.getElementById("termsCheck");
  const submit = document.getElementById("checkout");
  if (!submit) return;

  //eギフト チェックボックス
  const checkbox_eGift = document.getElementById("isAgreeGiftOrderCheck");

  //デジタル商品 チェックボックス
  const checkbox_digital = document.getElementById("isAgreeDigitalContentOrderCheck");

  //判定フラグ
  //eギフトやデジタル商品がなければ判定をスキップするためフラグはtrueに
  let termsFlag = termsCheck ? termsCheck.checked : false;
  let eGiftFlag = checkbox_eGift ? checkbox_eGift.checked : true;
  let digitalFlag = checkbox_digital ? checkbox_digital.checked : true;

  function updateSubmitState() {
    // is-activeの付け外し
    if (termsFlag && eGiftFlag && digitalFlag) {
      submit.classList.add("is-active");
      submit.disabled = false;
      submit.removeAttribute("aria-disabled");
    } else {
      submit.classList.remove("is-active");
      submit.disabled = true;
      submit.setAttribute("aria-disabled", "true");
    }
  }

  if (termsCheck) {
    termsCheck.addEventListener("change", () => {
      termsFlag = termsCheck.checked;
      updateSubmitState();
    });
  }
  if (checkbox_eGift) {
    checkbox_eGift.addEventListener("change", () => {
      eGiftFlag = checkbox_eGift.checked;
      updateSubmitState();
    });
  }
  if (checkbox_digital) {
    checkbox_digital.addEventListener("change", () => {
      digitalFlag = checkbox_digital.checked;
      updateSubmitState();
    });
  }

  // 初期状態のチェック（ページ読み込み時）
  updateSubmitState();

  const observer = new MutationObserver(() => {
    // disabledが外れた（= false になった）時だけチェック
    if (!submit.disabled) {
      if (!submit.classList.contains("is-active")) {
        // is-activeクラスがなければ、すぐdisabledを戻す
        submit.disabled = true;
        submit.setAttribute("aria-disabled", "true");
        //console.log('is-active無しなのでdisabledに戻しました');
      } else {
        // is-activeがあれば、disabled解除なのでaria-disabledも解除
        submit.removeAttribute("aria-disabled");
      }
    } else {
      // すでにdisabledの場合は、aria-disabledもtrueに揃える
      submit.setAttribute("aria-disabled", "true");
    }
  });

  // submit要素の属性変化を監視
  observer.observe(submit, { attributes: true, attributeFilter: ["disabled"] });

  //IE対応--
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const trident = ua.indexOf("Trident/");

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  const cartSubmitInput = document.createElement("input");
  cartSubmitInput.setAttribute("name", "checkout");
  cartSubmitInput.setAttribute("type", "hidden");
  document.querySelector("#cart").appendChild(cartSubmitInput);
  document.querySelector("#checkout").addEventListener("click", function (event) {
    document.querySelector("#cart").submit();
  });
})();
